import { render, staticRenderFns } from "./salaries.vue?vue&type=template&id=e1e11cfa"
import script from "./salaries.vue?vue&type=script&lang=js"
export * from "./salaries.vue?vue&type=script&lang=js"
import style0 from "./salaries.vue?vue&type=style&index=0&id=e1e11cfa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports